<script>
    import DeleteButton from "../Cards/DeleteButton.svelte";

    export let fullTextSubject;
    export let subject = "";
    export let isEdit = false;
    export let handleSubmit;
    export let isButtonDisabled = false;
    export let handleDelete;
    export let hasDeleteButton = true;
</script>

<div class="h-full relative flex flex-col gap-3 w-full shadow-lg rounded bg-white min-h-400-px p-4">
    <div class="flex flex-col md:flex-row gap-2 justify-between">
        <div class="font-semibold text-3xl h-9">
            {!!fullTextSubject ? fullTextSubject : isEdit ? "Modifica" : "Crea"} {subject}
        </div>

        <div class="flex flex-col md:flex-row items-center justify-end gap-2 w-auto">
            <slot name="header-content" />

            {#if isEdit && hasDeleteButton}
                <DeleteButton
                    on:delete={handleDelete}
                    isButtonDisabled={isButtonDisabled}
                    buttonText="Elimina"
                    message="Vuoi eliminare {subject}?"
                />
            {/if}
        </div>
    </div>

    <form on:submit|preventDefault={handleSubmit} class="flex flex-col justify-between gap-3 w-full h-full">
        <div class="flex flex-col gap-3">
            <slot />
        </div>

        <div class="flex justify-center">
            <button disabled={isButtonDisabled} type="submit" class="submit-button px-4 h-12 text-white transition hover:shadow-lg">
                SALVA
            </button>
        </div>

        <slot name="footer-content" />
    </form>
</div>

<style>
    .submit-button {
        background-color: rgba(56, 189, 248);
        border: none !important;
        outline: none !important;
    }

    .submit-button:disabled {
        background-color: rgba(56, 189, 248, 0.5);
        cursor: default;
    }
</style>